// extracted by mini-css-extract-plugin
export var flex = "flex-module--flex--+k+8n";
export var noHorizontalMargin = "flex-module--noHorizontalMargin--+os1j";
export var flex21 = "flex-module--flex21--A1QTm";
export var flex12 = "flex-module--flex12--p1sAv";
export var alignStart = "flex-module--alignStart--aZuvq";
export var collapseOnMd = "flex-module--collapseOnMd--aZSvW";
export var noCollapseMargin = "flex-module--noCollapseMargin--zRdwK";
export var reverseOnMd = "flex-module--reverseOnMd--q7q0D";
export var reverseOnSm = "flex-module--reverseOnSm--qz-bO";